
// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.priceListSearch.pricelist', {
        url: '/{articleId}',
        views: {
            "productView@product": {
                templateUrl: 'main/product/articles/pricelistmanagement/pricelistmanagement.tpl.html',
                controller: 'PriceListController as vm'
            }
        },
        resolve: {
            article: articleResolver,
            locations: locationsResolver
        }
    });
}

// @ngInject
function articleResolver($stateParams, PricelistsApiService) {
    return PricelistsApiService.getProduct($stateParams.articleId);
}

// @ngInject
function locationsResolver($stateParams, PricelistsApiService) {
    return PricelistsApiService.getLocations();
}

// @ngInject
function PriceListController(article, $scope, locations, PricelistsApiService, ToasterService, loadSpinnerService) {
    var vm = this;

    vm.locations = locations;
    vm.selectedArticle = article;
    vm.selectedLocation = {};
    vm.newPrice = "";
    vm.save = save;
    vm.removeOverridePrice = removeOverridePrice;
    vm.foundExistingPrice = false;

    activate();

    function activate() {
        $scope.$watch(function() {return vm.selectedLocation;}, function() {
            loadPriceForCurrentLocation();
        });

        // TODO: NO! Remove this ugly hack. Implement default locations for real instead.
        var defaultLocation = _.find(vm.locations, function(location) {
            return location.locationName === "Pop-Up Stinsen";
        });
        if (defaultLocation) {
            vm.selectedLocation = defaultLocation;
        }
    }

    function loadPriceForCurrentLocation() {
        _.forEach(vm.selectedArticle.articleVariants, function(articleVariant) {
            var relevantArticleVariantPrice = _.find(articleVariant.articleVariantPrices, function(articleVariantPrice) {
                return articleVariantPrice.location.id === vm.selectedLocation.id;
            });

            if (relevantArticleVariantPrice) {
                vm.newPrice = relevantArticleVariantPrice.salesPrice;
                vm.foundExistingPrice = true;
            } else {
                vm.newPrice = "";
                vm.foundExistingPrice = false;
            }
        });
    }

    function save() {
        loadSpinnerService.start('mainSpinner');

        PricelistsApiService.updateOverridePrice(vm.selectedArticle.id, vm.selectedLocation.id, vm.newPrice).then(function(response) {
            vm.selectedArticle = response.data;
        }, function(error) {
            ToasterService.showError(error.message);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function removeOverridePrice() {
        loadSpinnerService.start('mainSpinner');

        PricelistsApiService.removeOverridePrice(vm.selectedArticle.id, vm.selectedLocation.id).then(function(response) {
            vm.newPrice = "";
            vm.selectedArticle = response.data;
        }, function(error) {
            ToasterService.showError(error.message);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }
}

angular
    .module('product.articles.pricelist', [])
    .config(stateConfig)
    .controller('PriceListController', PriceListController);
